<template>
    <label class="checkbox flex flex-align" :class="{disabled, error, checked}">
        <input class="checkbox-input" type="checkbox" :disabled="disabled" :checked="checked" @input="update" />
        <div class="checkbox-label" v-if="label">{{label}}</div>
    </label>
</template>

<script>
    export default {
        name: 'Checkbox',
        props: {
            label: String,
            error: Boolean,
            checked: Boolean,
            disabled: Boolean
        },
        methods: {
            update($event){
                this.$emit('update:checked', $event.target.checked);
                this.$emit('input', $event.target.checked);
            }
        }
    }
</script>

<style scoped lang="less">
    @import "~@/assets/less/variables";
    @import "~@/assets/less/mixins";

    label.checkbox
    {
        border: 1px solid var(--input-border-color);
        background: var(--input-background-color);
        padding: 4px 10px;
        height: 40px;
        line-height: 30px;
        font-size: 16px;
        color: var(--secondary-text-color);
        border-radius: 3px;
        text-transform: none;
        margin: 0;
        cursor: pointer;

        &:focus-within, &:active
        {
            border-color: @base;
            box-shadow: 0 0 0 3px fade(@base, 30%);
        }

        input.checkbox-input
        {
            background: var(--secondary-text-color);
            margin: 0;
            border: 0;
            transition: background-color ease 0.2s;

            &::after
            {
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                content: "";
                background: url('~@/assets/icons/white/check.svg') 1px 3px no-repeat;
                background-size: 18px auto;
                transform: scale(0);
                transition: all ease 0.15s;
                opacity: 0;
            }

            &:checked
            {
                background: @base;

                &::after
                {
                    transform: scale(1);
                    opacity: 1;
                }
            }
        }

        .checkbox-label
        {
            margin: 0 0 0 10px;
            user-select: none;
            white-space: nowrap;
        }
    }
</style>
